import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import textbookReducer from './slices/textbookSlice'
import diagnosisReducer from './slices/diagnosisSlice'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    textbook: textbookReducer,
    diagnosis: diagnosisReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

